import * as React from 'react';
import './style/index.scss';
import { ContactUsFormContent } from './ContactUsFormContent';
import { SubmissionSuccessForm } from './SubmissionSuccessForm';
export class ContactUsFormWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.onSubmissionCallBack = (ticketId, isSubmissionSuccess) => {
            this.setState({ ticketId, isSubmissionSuccess });
        };
        this.onClickNewRequest = () => {
            this.setState({ ticketId: null, isSubmissionSuccess: null, key: this.state.key + 1 });
        };
        this.onSubmissionCallBack = this.onSubmissionCallBack.bind(this);
        this.onClickNewRequest = this.onClickNewRequest.bind(this);
        this.state = {
            ticketId: null,
            isSubmissionSuccess: null,
            key: 0
        };
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.state.isSubmissionSuccess === null
                && this.state.ticketId === null
                && (React.createElement(ContactUsFormContent, { productName: this.props.productName, pageSource: this.props.pageSource, onSubmitFn: this.props.onSubmitFn, onClose: this.props.onClose, onSubmissionCallBack: this.onSubmissionCallBack, articles: this.props.articles, initialSearchTerms: this.props.initialSearchTerms, isVisible: this.props.isVisible, searchTermCallBack: this.props.searchTermCallBack, goToArticle: this.props.goToArticle, key: this.state.key, showCaseDeflection: this.props.showCaseDeflection })),
            this.state.isSubmissionSuccess &&
                this.state.ticketId &&
                React.createElement(SubmissionSuccessForm, { ticketId: this.state.ticketId, onClickNewRequest: this.onClickNewRequest })));
    }
}
